const country = {
  country: "Country",
  name: "Name",
  schoolYearType: "School year type",
  defaultLanguage: "Default language",
  currency: "Currency",
  subscriptionPrice: "Subscription price",
  saveCountryQuestion: "Save this country?",
  saveCountryDescription:
    "Warning: changing the currency or subscription price will only apply to new subscriptions or renewals.",
  countryDetail: "Country details",
  countryCreation: "Create a country",
  countries: "Countries",
};

export default country;
